// Redux
import { Dispatch } from 'redux';

// Action Creators
import { setLocationIds } from '../actionCreators/locations.actionCreators';

export const setLocations = (dispatch: Dispatch<any>, value: any) => {
  dispatch(setLocationIds(value));
};
